import Box from '@mui/material/Box';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { NotFoundScreen } from '../../components/alliance/system-screens';
import { AppContext } from '../../contexts/app-context';

/**
 * Unknown routes render the 404 inside the shell (the App Bar and sidebar
 * stay usable) instead of silently redirecting home. It skips
 * RouteContainer, so no ad carousel sits around the screen.
 */
export function NotFound() {
  // Context
  const { dispatch } = React.useContext(AppContext);
  // Hooks
  const navigate = useNavigate();

  React.useEffect(() => {
    // The App Bar shows the page title on desktop
    dispatch({ type: 'SET_ROUTE_TITLE', payload: 'Page not found' });
  }, [dispatch]);

  return (
    <Box
      component="main"
      sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}
    >
      <Helmet>
        <title>Dashboard · Page not found</title>
      </Helmet>

      <NotFoundScreen onHome={() => navigate('/home')} />
    </Box>
  );
}
